<template>
  <transition name="fade-up-slide">
    <div class="lr2-modal" v-show="show" @click="close">
      <div class="lr-box" @click.stop>
        <div class="lr-box-head">Room & guests</div>

        <div class="room-box d-flex align-center">
          <i class="fas fa-door-open fa-fw"></i>
          <div>
            {{ roomCount }}
            {{ roomCount > 1 ? 'rooms' : 'room' }}
            for {{ adults }} {{ adults > 1 ? 'adults' : 'adult' }}
            <span v-if="children">
              &middot; {{ children }}
              {{ children > 1 ? 'children' : 'child' }}
            </span>
          </div>
        </div>

        <div class="d-flex justify-space-between trav-form">
          <label>
            Adults
            <span>Ages 18+ <small>(2 per room)</small></span>
          </label>
          <div class="d-flex align-center trav-counter">
            <i :class="['fas fa-minus-circle', {maxed:adults === 1}]" @click="minus('adults')"></i>
            <span>{{ adults }}</span>
            <i :class="['fas fa-plus-circle', {maxed:adults === 10}]" @click="add('adults')"></i>
          </div>
        </div>

        <div class="d-flex justify-space-between trav-form">
          <label>
            Children
            <span>Ages 0 to 17</span>
          </label>
          <div class="d-flex align-center trav-counter">
            <i :class="['fas fa-minus-circle', {maxed:children === 0}]" @click="minus('children')"></i>
            <span>{{ children }}</span>
            <i :class="['fas fa-plus-circle', {maxed:children === 10}]" @click="add('children')"></i>
          </div>
        </div>

        <div class="lr-box-head sub" v-if="children">Age of children</div>
        <div class="d-flex justify-space-between child-age" v-if="children">
          <div class="ca-box d-flex justify-space-between align-center" v-for="c in children" :key="c">
            <label>Child {{ c }}</label>
            <select v-model="hotel.childAge[c - 1]">
              <option v-for="x in 17" :key="x" :value="x">{{ x }} {{ x === 1 ? 'yr' : 'yrs'}}</option>
            </select>
          </div>
        </div>

        <!-- <div class="lr-box-head">How many rooms do you need?</div>
        <div class="d-flex justify-space-between trav-form">
          <label>
            Room count
          </label>
          <div class="d-flex align-center trav-counter">
            <i :class="['fas fa-minus-circle', {maxed:roomCount === 1}]" @click="roomUpdate('minus')"></i>
            <span>{{ roomCount }}</span>
            <i :class="['fas fa-plus-circle', {maxed:roomCount === 4}]" @click="roomUpdate('add')"></i>
          </div>
        </div> -->

        <!-- <div class="d-flex justify-space-between trav-form">
          <label>
            Infants
            <span>Below 2 years old</span>
          </label>
          <div class="d-flex align-center trav-counter">
            <i :class="['fas fa-minus-circle', {maxed:infants === 0}]" @click="minus('infants')"></i>
            <span>{{ infants }}</span>
            <i :class="['fas fa-plus-circle', {maxed:infants === 10}]" @click="add('infants')"></i>
          </div>
        </div> -->

        <div class="d-flex trav-btn-box">
          <span class="lr-btn" @click="apply">Search</span>
        </div>

        <!-- <div class="trav-notes">Note: Maximum of 2 luggage per passenger.</div> -->
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'travellers',
  props: ['noCommit'],
  data () {
    return {
      adults: 1,
      children: 0,
      infants: 0,
      show: false
    }
  },
  computed: {
    booking () { return this.$store.state.booking },
    travellers () { return this.booking.filters.travellers },
    hotel () { return this.$store.state.hotel },
    roomCount: {
      get () { return this.hotel.roomCount },
      set (x) { this.$store.commit('hotel/setData', {roomCount: x}) }
    }
  },
  methods: {
    toggleModal (x) {
      this.show = x
    },
    close () {
      this.show = false
    },
    minus (x) {
      if ((x === 'adults' && this.adults === 1) || (x !== 'adults' && this[x] === 0)) return
      this[x]--
    },
    add (x) {
      if (this[x] === 10) return
      this[x]++
    },
    roomUpdate (x) {
      if (
        (x === 'add' && this.roomCount >= 4) ||
        (x === 'minus' && this.roomCount === 1)
      ) { return }

      if (x === 'add') this.roomCount++
      else this.roomCount--
    },
    apply () {
      let total = this.adults + this.children + this.infants
      if (this.noCommit) {
        this.$emit('travelersVal', {
          total: total,
          adult: this.adults,
          children: this.children,
          infants: this.infants
        })
      } else {
        this.$store.commit('booking/setTravellersData', {
          total: total,
          adult: this.adults,
          children: this.children,
          infants: this.infants
        })

        this.$emit('submit')

        // if (window.gtag) { // eslint-disable-line
        //   gtag( // eslint-disable-line
        //     'event',
        //     'Flight Booking - Travel Count',
        //     {
        //       total: total,
        //       adult: this.adults,
        //       children: this.children,
        //       infants: this.infants
        //     }
        //   )
        // }
      }
      this.close()
    }
  },
  watch: {
    adults (x) {
      this.roomCount = Math.ceil(x / 2)
    }
  },
  mounted () {
    this.adults = this.travellers.adult
    this.children = this.travellers.children
    this.infants = this.travellers.infants
  }
}
</script>

<style lang="scss" scoped>
.lr-box{
  padding: 20px 30px;
  width: 100%;
  max-width: 470px;
  text-align: left;
  line-height: 1;
}
.lr-box-head{
  color: #192024;
  font-size: 21px;
  font-weight: bold;
  letter-spacing: .6px;
  margin-bottom: 15px;
  
  &.sub{
    border-top: 1px solid #ddd;
    margin-bottom: 15px;
    font-size: 18px;
    padding-top: 20px;
  }
}
.room-box{
  background: rgba(255, 223, 151, .22);
  padding: 13px 10px;
  margin-bottom: 15px;
  color: #ECAE20;
  border-radius: 6px;
  letter-spacing: .5px;
  gap: 10px;
  font-weight: 600;
}
.trav-form{
  margin-bottom: 30px;
  label{
    font-size: 18px;
    font-weight: 600;
    color: #192024;

    span{
      display: block;
      font-size: 14px;
      color: #5E6E7F;
      margin-top: 3px;
      font-weight: 500;
      letter-spacing: .5px;
    }
  }
  .trav-counter{
    gap: 10px;

    i{
      font-size: 25px;
      color: #5E6E7F;
      cursor: pointer;

      &.maxed{
        color:#BEBEBE;
        cursor: default;
      }
    }
    span{
      display: inline-block;
      text-align: center;
      width: 40px;
      font-size: 21px;
      font-weight: 600;
    }
  }
}
.lr-btn{
  margin-left: auto;
  padding: 20px 50px;
  font-size: 16px;
}
.trav-notes{
  font-size: 13px;
  letter-spacing: .5px;
  text-align: center;
}

.child-age{
  flex-wrap: wrap;
  gap: 16px 0;
}
.ca-box{
  width: 48%;
  gap: 10px;

  label{
    width: 120px;
    color: #5E6E7F;
  }
  select{
    padding: 5px;
  }
}

.lr-btn{
  width: 100%;
  margin-top: 30px;
}

@media only screen and (max-width: 641px) {
  .lr2-modal{
    overflow: none;
  }
  .lr-box{
    height: 100%;
    max-width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }
  .trav-btn-box{
    flex-grow: 1;
    align-items: end;
  }
}
</style>



// WEBPACK FOOTER //
// TravellersModal.vue?46f5bc9d